import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ServiceCard = ({ title, description, fullDescription, images }) => {
  const navigate = useNavigate();
  const [translateX, setTranslateX] = useState(0);
  const [expanded, setExpanded] = useState(false);

  const speed = 0.3;

  useEffect(() => {
    if (!images || images.length === 0) return;
    const interval = setInterval(() => {
      setTranslateX((prev) =>
        prev <= -images.length * 200 ? 0 : prev - speed
      );
      
    }, 20);
    return () => clearInterval(interval);
  }, [images]);

  return (
    <div className="max-w-4xl mx-auto p-6 rounded-2xl my-8 bg-white shadow-md">
      {/* Title */}
      <h2 className="text-3xl font-bold mb-4 text-center">{title}</h2>

      {/* Short + Long description */}
      <p className="text-gray-700 text-lg mb-4 text-center">
        {description}
        {expanded && (
          <span className="block mt-3 text-gray-600">{fullDescription}</span>
        )}
      </p>
      <div className="text-center">
<button
  onClick={() => setExpanded(!expanded)}
  style={{
    marginBottom: 10,
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    textDecoration: 'none',
    color:"blue",
 
  }}
>
  {expanded ? 'Read Less' : 'Read More'}
</button>
      </div>

      {/* Scrolling logos */}
      {images && images.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
          <div className="overflow-hidden w-full bg-gray-100 py-1">
            <div
              className="flex items-center flex-nowrap gap-8"
              style={{
            display: "flex",
            flexWrap: "nowrap",
            whiteSpace: "nowrap",
                transform: `translateX(${translateX}px)`,
            transition: "transform 0s linear",
              }}
            >
              {[...images, ...images].map((src, index) => (
                <img
                  key={index}
                  src={src}
                  alt={`Logo ${index + 1}`}
                  className="mx-3"
                  style={{
                    width: '120px',
                    flexShrink: 0,
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Minimum Order */}
      <div className="flex items-center justify-center mb-4">
        <h3
  style={{
    color: 'red',
    textAlign: 'center',
    fontWeight: 600,
    marginBottom: 16,
  }}
>
  Minimum Order: 48 pcs
</h3>
      </div>

      {/* Quote button */}
      <div className="text-center">
        <button
          style={{
            marginBottom: 30,
            height: 40,
            padding: '0 15px',
            backgroundColor: 'black',
            color: 'white',
            cursor: 'pointer',
          }}
          onClick={() => navigate('/quote')}
        >
          Get a Quote
        </button>
      </div>
    </div>
  );
};

export default ServiceCard;
